import React from "react";

export function HeroIllustration() {
  return (
    <div className="imgCard" aria-hidden="true">
      <svg viewBox="0 0 620 360" className="imgCard__svg">
        <defs>
          <linearGradient id="gradA" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#40b24f" stopOpacity="0.9" />
            <stop offset="1" stopColor="#4a7cb8" stopOpacity="0.9" />
          </linearGradient>
          <radialGradient id="glow" cx="50%" cy="40%" r="60%">
            <stop offset="0" stopColor="white" stopOpacity="0.18" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </radialGradient>
        </defs>

        <rect
          x="12"
          y="12"
          width="596"
          height="336"
          rx="26"
          fill="rgba(255,255,255,0.05)"
          stroke="rgba(255,255,255,0.12)"
        />
        <circle cx="180" cy="150" r="120" fill="url(#glow)" />
        <circle cx="440" cy="190" r="140" fill="url(#glow)" />

        <path
          d="M90 250 C 160 160, 240 160, 310 240 S 460 330, 540 200"
          fill="none"
          stroke="url(#gradA)"
          strokeWidth="6"
          strokeLinecap="round"
        />

        <g opacity="0.9">
          <rect
            x="64"
            y="70"
            width="210"
            height="44"
            rx="14"
            fill="rgba(0,0,0,0.20)"
            stroke="rgba(255,255,255,0.12)"
          />
          <rect
            x="80"
            y="84"
            width="140"
            height="10"
            rx="5"
            fill="rgba(255,255,255,0.65)"
          />
          <rect
            x="64"
            y="128"
            width="260"
            height="56"
            rx="16"
            fill="rgba(0,0,0,0.20)"
            stroke="rgba(255,255,255,0.12)"
          />
          <rect
            x="84"
            y="148"
            width="220"
            height="10"
            rx="5"
            fill="rgba(255,255,255,0.55)"
          />
        </g>

        <g>
          <rect
            x="360"
            y="84"
            width="190"
            height="44"
            rx="14"
            fill="rgba(64,178,79,0.12)"
            stroke="rgba(64,178,79,0.28)"
          />
          <rect
            x="376"
            y="98"
            width="140"
            height="10"
            rx="5"
            fill="rgba(255,255,255,0.75)"
          />
          <rect
            x="330"
            y="148"
            width="240"
            height="120"
            rx="22"
            fill="rgba(74,124,184,0.10)"
            stroke="rgba(74,124,184,0.28)"
          />
          <circle cx="360" cy="210" r="28" fill="rgba(255,255,255,0.10)" />
          <circle cx="420" cy="210" r="28" fill="rgba(255,255,255,0.10)" />
          <circle cx="480" cy="210" r="28" fill="rgba(255,255,255,0.10)" />
        </g>
      </svg>
      <div className="imgCard__labelRow">
        <span className="imgPill imgPill--g">Access</span>
        <span className="imgPill imgPill--b">Structure</span>
        <span className="imgPill">Capital</span>
      </div>
    </div>
  );
}

export function PillarIcon({ variant = "g" }) {
  return (
    <span className={`pIcon pIcon--${variant}`} aria-hidden="true">
      <svg viewBox="0 0 24 24" className="pIcon__svg">
        <path
          d="M4 13.5c3.2-5.2 8.8-8 13.6-8.9"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
        />
        <path
          d="M5.2 19.5c4-1.9 8-2.6 12-2.6"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
        />
      </svg>
    </span>
  );
}
